import { AppEvents } from "./../../../app-events";
import { IRequestOptions } from "./../../../search/interfaces/request-options";
import { GenericListTabView } from "./generic-list-tab";

const dom = {
    SHOW_ALL_RELATIONS_LINK: ".js-jurisdiction-filter",
    RELATIONS_INFO: ".relations-jurisdiciton-label",
    RELATIONS_BAR: ".relations-jurisdiction-info",
    COLLAPSE_HEADING: ".collapse-heading",
    MORE_BUTTON: ".category-more-button",

};

export class CategoryDocumentListTabView extends GenericListTabView {

    public onShow() {
        super.onShow();
        this.attachSearchAllButton();
    }

    public events(): Backbone.EventsHash {
        const events = super.events();
        events["click " + dom.MORE_BUTTON] = (e) => this.moreButtonClick(e);
        return events;
    }

    protected setJurisdictionResultsMessage() { // We never want this bar for category documents
        const $link = this.$(dom.SHOW_ALL_RELATIONS_LINK);
        const $bar = this.$(dom.RELATIONS_BAR);
        const $label = this.$(dom.RELATIONS_INFO);

        $link.hide();
        $bar.hide();
        $label.hide();
        return;
    }

    private attachSearchAllButton() {
        const order = this.model.Identifier === "recent-cases" ? "MostRecent" : "Relevance";
        const btn = `<div style="text-align:center; margin-top:19px;"> <button class="category-more-button btn" data-order="${order}">Search all <strong>${this.model.Data.Title}</strong> cases</button>    </div>`;
        this.$(".list-region").append(btn);

    }

    private moreButtonClick(e: JQueryMouseEventObject) {
        const $target = $(e.currentTarget);
        e.stopPropagation();
        const options: IRequestOptions = {
            page: 1,
            query: "Category[\"" + this.model.Data.Title + "\"]",
            order: $target.attr("data-order"),
            materialTypes: ["Case"],
            includedCategoryFilters: [],
            includedProductFilters: null
        };

        this.appEvents.trigger(AppEvents.ResetSearch);
        this.appEvents.trigger(AppEvents.SearchRequest, options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/category-doc-list-tab.ts